export default __webpack_public_path__ + "static/matcapimg2-369719dcea9103c7447179adb8fdf1ff.jpg";